import script from "./WebAssistant.vue?vue&type=script&lang=ts&setup=true"
export * from "./WebAssistant.vue?vue&type=script&lang=ts&setup=true"

import "./WebAssistant.vue?vue&type=style&index=0&id=2bd172d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd172d6"]])

export default __exports__